import _ from 'underscore';
import $ from 'jquery';

export default class NewsletterRecipientsSent {
  constructor($scope, $timeout, NewsletterService) {
    $scope.tabs = [
      {
        title: 'Users',
        recipients: []
      }
    ];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.load_recipients = function() {
      $scope.loading = true;
      NewsletterService.get_recipients(window.newsletter.id, 0).success(function(data) {
        _.each(data.recipients, function(recipient) {
          $scope.allocate_recipient(recipient);
        });
        $scope.loading = false;
      });
    };

    $scope.allocate_recipient = function(recipient) {
      $scope.add_tab_recipient(recipient.is_special ? 1 : 0, recipient);
    };

    $scope.add_tab_recipient = function(index, recipient) {
      if (_.indexOf($scope.tabs[index].recipients, recipient) < 0)
        $scope.tabs[index].recipients.push(recipient);
    };

    $scope.get_xls = function(recipient, xls_filename) {
      $timeout(function() {
        $('form#getXLS input[name="user_id"]').val(recipient.user_id);
        $('form#getXLS input[name="xls_filename"]').val(xls_filename);
        $('form#getXLS').submit();
      }, 300);
    };

    $scope.move_to_pending = function(recipient) {
      recipient.moving_to_pending = true;
      NewsletterService.set_recipient_pending(recipient.id, true).success(function(data) {
        if (data.success) {
          $scope.tabs[0].recipients.splice(_.indexOf($scope.tabs[0].recipients, recipient), 1);
          recipient.moving_to_pending = false;
        }
      });
    };

    $scope.quick_search = function(tab_index) {
      window.filter_table('table.tab' + tab_index, $scope.tabs[tab_index].query);
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.newsletter = window.newsletter;
      $scope.current_page = 'recipients_sent';
      $scope._ = _;
      $scope.load_recipients();
    };

    $scope.init();
  }
}

NewsletterRecipientsSent.$inject = ['$scope', '$timeout', 'NewsletterService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/newsletter-recipients-sent.ctrl.js